const DotsIcon = ({ height = 8, width = 5, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="1" cy="1" r="1" fill="currentColor" />
      <circle cx="4" cy="1" r="1" fill="currentColor" />
      <circle cx="1" cy="4" r="1" fill="currentColor" />
      <circle cx="4" cy="4" r="1" fill="currentColor" />
      <circle cx="1" cy="7" r="1" fill="currentColor" />
      <circle cx="4" cy="7" r="1" fill="currentColor" />
    </svg>
  );
};

export default DotsIcon;
